/**
 * Set up routing for all Sponsor views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import sponsor views
import AdminSponsorList from './views/AdminSponsorList.js.jsx';
import AdminCreateSponsor from './views/AdminCreateSponsor.js.jsx';
import AdminSingleSponsor from './views/AdminSingleSponsor.js.jsx';
import AdminUpdateSponsor from './views/AdminUpdateSponsor.js.jsx';

class SponsorAdminRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    let singleSponsorUpdatePath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/update'), 0);
    return (
      <Switch>
        <YTRoute
          breadcrumbs={[{display: 'All sponsors', path: null }]}
          component={AdminSponsorList}
          exact
          path="/admin/sponsors"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display: 'All sponsors', path: '/admin/sponsors' }, {display: 'New sponsor', path: null }]}
          component={AdminCreateSponsor}
          exact
          path="/admin/sponsors/new"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display: 'All sponsors', path: '/admin/sponsors' }, {display: 'Sponsor details', path: null}]}
          component={AdminSingleSponsor}
          exact
          path="/admin/sponsors/:sponsorId"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display: 'All sponsors', path: '/admin/sponsors' }, {display: 'Sponsor details', path: singleSponsorUpdatePath}, {display: 'Update', path: null }]}
          component={AdminUpdateSponsor}
          exact
          path="/admin/sponsors/:sponsorId/update"
          role="admin"
        />
      </Switch>
    )
  }
}

export default withRouter(SponsorAdminRouter);



// WEBPACK FOOTER //
// modules/sponsor/SponsorAdminRouter.js.jsx